// ** Third Party Imports
import { Link } from 'react-router-dom'
import styled, { css, type CSSProperties } from 'styled-components'

interface IconButtonProps {
	$width: number
	$height: number
	$disabled?: boolean
	$styles?: CSSProperties
}

const styles = css<IconButtonProps>`
	border: none;
	cursor: pointer;
	display: flex;
	outline: none;
	background: none;
	flex-shrink: 0;

	/* Custom icon height & width */
	svg {
		width: ${({ $width }) => $width}rem;
		height: ${({ $height }) => $height}rem;
	}

	${({ $disabled }) =>
		$disabled &&
		`
      cursor: default;
      opacity: 0.5;
      pointer-events: none;
  `}
`

export const StyledButton = styled.button<IconButtonProps>`
	${styles}
	${({ $styles }) => ({ ...$styles })}
`

export const StyledLink = styled(Link)<IconButtonProps>`
	${styles}
`

export const StyledExternalLink = styled.a<{
	$width: number
	$height: number
	$disabled?: boolean
}>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
	pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
	cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
	svg {
		width: ${({ $width }) => $width}rem;
		height: ${({ $height }) => $height}rem;
	}
`
